<template>
  <DefaultPage>
    <div class="home-hero">
      <HeroTexture class="home-hero__texture" />
      <HeroTextureTwo class="home-hero__texture-two" />
      <Banner
        aria-label="Leading the Way - The 2024 Annual Report"
        class="home-hero__banner"
        data-aos="fade-up"
        data-aos-duration="1000"
      />
    </div>
    <HomeQuotes />
    <div class="home-texture-gap">
      <img src="@/assets/texture-home-gap.png" />
    </div>
    <HomeLetter />
    <TheSubFooter next-route="/the-path-forward" />
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import TheSubFooter from '@/components/footer/TheSubFooter';
import HomeQuotes from '@/components/home/HomeQuotes';
import HomeLetter from '@/components/home/HomeLetter';
import Banner from '@/assets/ar-banner.svg';
import HeroTexture from '@/assets/texture-home-hero.svg';
import HeroTextureTwo from '@/assets/texture-home-hero-2.svg';

export default {
  name: 'Home',
  components: {
    DefaultPage,
    TheSubFooter,
    HomeQuotes,
    HomeLetter,
    Banner,
    HeroTexture,
    HeroTextureTwo,
  }
};
</script>
